/**
 * Sélecteur de langue.
 *
 * Un `<select>` natif plutôt qu'un composant maison : il est accessible au clavier et au
 * lecteur d'écran sans effort, s'affiche correctement sur mobile, et l'interface ne
 * compte que deux langues — un menu déroulant complet serait disproportionné.
 *
 * Les libellés sont écrits **dans leur propre langue** (« Français », « English ») : un
 * utilisateur qui a atterri dans la mauvaise langue doit pouvoir trouver la sienne sans
 * la comprendre.
 */

import { LOCALES, LOCALE_LABELS, useLocaleStore, useT, type Locale } from '../i18n/index.js';

export function LanguageSwitcher(): React.JSX.Element {
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);
  const translator = useT();

  return (
    <label className="language-switcher">
      <span className="sr-only">{translator.t('app.language')}</span>
      <select
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
        aria-label={translator.t('app.language')}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
